import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { AlbumFolderWithCreatorBrandDetails } from '../../graphql/queries/album-folder';
import DiscoverAlbumFolderStart from '../../components/discover/DiscoverAlbumFolderStart';

const withAlbumFolder = graphql(AlbumFolderWithCreatorBrandDetails, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumFolderId,
    },
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    loading,
    albumFolder,
  }),
});

const mapStateToProps = ({ auth }) => ({
  authenticated: auth.authenticated,
});

export default compose(
  withRouter,
  withAlbumFolder,
  connect(mapStateToProps, null),
)(DiscoverAlbumFolderStart);
